import type { FC } from 'react';

import { IDADE_MINIMA, useConsentimento } from '../../../../logica/consentimento/useConsentimento';
import { Consentimento } from './Consentimento';

// /consentimento — liga a lógica à tela.
const ConsentimentoLigado: FC = () => <Consentimento {...useConsentimento()} idadeMinima={IDADE_MINIMA} />;

export default ConsentimentoLigado;
